import { Box } from "@mui/material";
import InfoMessage from "src/shared/components/InfoMessage";
import WarningIcon from "@mui/icons-material/Warning";
import { MessageVariant } from "src/shared/enums/messageTypes/messageTypes";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const DemoEnvMsg = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Box
      sx={{
        mb: [
          "/",
          "/welcome/loginForm",
          "/welcomeGovChamber/login",
          "/welcomeGovRegion/loginForm",
          "/welcome/ggpsIntro",
        ].includes(location.pathname)
          ? -2
          : 0,
      }}
    >
      <InfoMessage
        message={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <WarningIcon />
            {t(
              "Το σύστημα βρίσκεται σε λειτουργία δοκιμαστικού περιβάλλοντος.",
            )}
          </Box>
        }
        variant={MessageVariant.Warning}
        closable={true}
      />
    </Box>
  );
};
